export function quizSteps() {
    const _document = this._document;
    const stepsWrap = _document.querySelector(".steps-wrap");
    const steps = stepsWrap.querySelectorAll(".step");
    const pagination = _document.querySelector(".pagination");
    const progressBar = pagination.querySelector(".progress-bar span");
    const pageTotalNum = pagination.querySelector(".page-total");
    const currentPageNum = pagination.querySelector(".current-page");
    const formWrap = _document.querySelector(".quiz-form-wrap");
    const questionsTotal = steps.length;
    const problemSelect = _document.getElementById("problemType");
    const jobToggler = _document.querySelectorAll("[name=\"radio-job\"]");
    const psychologicalBlock = _document.querySelector(".psychological-row");
    const physicalBlock = _document.querySelector(".physical-row");
    const haveJob = _document.querySelector(".have-job");
    let currentIndex = 0;


    function countPages(idx) {
        currentPageNum.textContent = `${idx < 9 ? "0" + (idx + 1) : idx + 1}`;
        progressBar.style.transform = `scaleX(${(idx + 1) / questionsTotal})`;
    }

    pageTotalNum.textContent = `${questionsTotal < 10 ? "0" + questionsTotal : questionsTotal}`;
    countPages(currentIndex);

    function changePage(index) {
        if (index > 0) {
            steps[index].previousElementSibling.classList.remove("current-step");
        }
        if (index < questionsTotal - 1) {
            steps[index].nextElementSibling.classList.remove("current-step");
        }
        steps[index].classList.add("current-step");
        countPages(index);
    }

    [...jobToggler].forEach((input) => {
        input.addEventListener("change", (event) => {
            if(event.target.value.toLowerCase() === "yes") {
                haveJob.classList.add("active");
            } else {
                haveJob.classList.remove("active");
            }
        });
    });

    problemSelect.addEventListener("change", (event) => {
        const problem = event.target.value.toLowerCase();
        switch (problem) {
        case "psychological":
            physicalBlock.classList.remove("active");
            psychologicalBlock.classList.add("active");
            break;
        case "physical":
            psychologicalBlock.classList.remove("active");
            physicalBlock.classList.add("active");
            break;
        case "both":
            psychologicalBlock.classList.add("active");
            physicalBlock.classList.add("active");
            break;
        default:
            psychologicalBlock.classList.remove("active");
            physicalBlock.classList.remove("active");
        }
    });

    _document.addEventListener("click", (event) => {
        if (event.target.classList.contains("prev")) {
            event.preventDefault();
            currentIndex -= 1;
            changePage(currentIndex);
        }
        if (event.target.classList.contains("next")) {
            event.preventDefault();
            currentIndex += 1;
            changePage(currentIndex);
        }
        if (event.target.classList.contains("go-to-form")) {
            event.preventDefault();
            stepsWrap.classList.remove("active");
            formWrap.classList.add("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/quiz-steps.js